import React, { useEffect, useState } from "react";
import { fetchData } from "./OverviewTables";
import { endpoints } from "config";
import gatewaysIcon from "assets/Icon_Menu_Blue_01.png";
import { GatewaySummary } from "./GatewaySummary";
import { Spinner } from "components/Spinner/Spinner";
import { SelectOption } from "components/dropdown/Dropdown";
import { Gateway, Task } from "pages/ProjectManagement/ProjectManagement.types";

export function sortByOrderNumber(a: Task | Gateway, b: Task | Gateway) {
  return a.orderNumber < b.orderNumber ? -1 : a.orderNumber > b.orderNumber ? 1 : 0;
}

interface CustomField {
  bActiveCustomField: boolean;
  customFieldsID: number;
  name: string;
  orderNumber: number;
  customFieldData: {
    customFieldType: string;
    possibleValues: SelectOption[];
  };
}

export interface Gateways {
  completedGatewaysCount: number;
  gatewaysCount: number;
  gateways: Gateway[];
}

type Props = {
  selectedId: string | number;
};

export const GatewaysSummary: React.FC<Props> = ({ selectedId }) => {
  const [data, setData] = useState<Gateways | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  useEffect(() => {
    fetchData(
      endpoints.projectmanagement.overviewGateways,
      selectedId,
      setData,
      null,
      setLoading,
      setError
    );
  }, []);

  let width = 0;
  if (data) {
    width = (data?.completedGatewaysCount / data?.gatewaysCount) * 100;
  }
  return (
    <div className="GatewaysSummaryContainer">
      <div className="HeaderContainer">
        <img className="Icon" src={gatewaysIcon} />
        <h4>GATEWAYS</h4>
        <div className="ProgressBarG">
          <div className="Progress" style={{ width: `${width}%` }}></div>
        </div>
        <div className="Status">{`${
          data?.completedGatewaysCount ?? "-"
        }/${data?.gatewaysCount ?? "-"} completed`}</div>
      </div>
      {data && data?.gateways ? (
        data?.gateways.length > 0 &&
        data?.gateways.sort(sortByOrderNumber).map((gateway, _i) => {
          return (
            <React.Fragment key={`${gateway.gatewayName}-${gateway.gatewaysID}-${_i}`}>
              <GatewaySummary gateway={gateway} projectID={selectedId as number} tab={"Overview"} />
            </React.Fragment>
          );
        })
      ) : (
        <div className="NoData">
          <div className="Text">No gateways found</div>
        </div>
      )}

      {!loading && !data && !error && (
        <div className="NoData">
          <div className="Text">No gateway data</div>
        </div>
      )}

      {error && (
        <div className="Error">
          <div className="Title">Error</div>

          <div className="Text">Something went wrong, please try again later</div>
        </div>
      )}

      {loading && <Spinner />}
    </div>
  );
};
